{
  "logLevel": "info",
  "apiSite": "https://stage.data.cms.gov",
  "useMockAdapter": false,
  "mockDelayResponse": 0,
  "mapBoxAccessToken": "pk.eyJ1IjoiY21zd25tZyIsImEiOiJja3FoNWc1MDQxN2ZzMnZudXdpYW9rYnc0In0._zLMukJnWlxv85bmfhsIjw",
  "mapBoxStateAbbrStyle": "mapbox://styles/cmswnmg/ckr2gf6eq1gwt17p8oieaaqmp",
  "mapBoxCountyStyle": "mapbox://styles/cmswnmg/ckuoib25z7v1519mwimbykquv",
  "mapBoxCbsaStyle": "mapbox://styles/cmswnmg/ckwqw54at0whb14nuoifjbzw7"
}
